// import SalesConstants from '@/pages/sales/salesconstants'

const FormConstants = Object.freeze({
  type: {
    SELECT: 'select',
    INPUT: 'input'
  },

  vtype: {
    INT: 'int',
    UNIT: 'unit',
    PERCENT: 'percent',
    PERCENTSIGN: 'percentsign',
    MONEY: 'money',
    MONEYSHORT: 'moneyshort',
    BOOLEAN: 'boolean'
  },

  MetricType: {
    VALUE: 0,
    PERCENT: 1
  },

  OPTIONS_METRIC_TYPE: [{
    id: 0,
    label: '$'
  }, {
    id: 1,
    label: '%'
  }],

  getOptionsMetricTypeString: (value) => {
    switch (value) {
      case 0: return '$'
      case 1: return '%'
      default: break
    }
    return '(invalid)'
  },

  OptionsYesNoUnknown: {
    YES: 1,
    NO: 0,
    UNKNOWN: 2,
    INVALID: -1
  },

  OPTIONS_YES_NO: [{
    label: 'Yes',
    id: 1,
    value: 1 // for old modules
  }, {
    label: 'No',
    id: 0,
    value: 0 // for old modules
  }],

  OPTIONS_YES_NO_UNKNOWN: [
    { value: 1, label: 'Yes' },
    { value: 0, label: 'No' },
    { value: 2, label: 'Unknown' }
  ],

  getOptionsYesNoString: (value) => {
    switch (value) {
      case 1: return 'Yes'
      case 0: return 'No'
      case 2: return 'Unknown'
      default: break
    }
    return '(invalid)'
  },

  parseOptionsYesNo: (value) => {
    switch (value) {
      // yes
      case true:
      case '1':
      case 1:
        return 1
      // no
      case false:
      case '0':
      case 0:
        return 0
      case '2':
      case 2:
        return 2
      case undefined:
      case null:
      default:
        return undefined
    }
  },

  OPTION_OTHER: -2,

  Colors: {
    PRIMARY: '#409EFF',
    SUCCESS: '#67C23A',
    DANGER: '#F56C6C',
    WARNING: '#E6A23C',
    INFO: '#303133'
  },

  // Date Formats
  // EL_DATE_FORMAT_DISPLAY: 'dd MMM, yyyy', // DD MMM, YYYY
  EL_DATE_FORMAT_DISPLAY: 'MM/dd/yyyy',
  EL_DATE_FORMAT: 'yyyy/MM/dd',
  Moment: {
    EL_DATE_FORMAT: 'yyyy/MM/DD',
  },

  // Charting

  // DEFAULT_CHART_COLORS: [
  //   SalesConstants.MarketColor.BLUE,
  //   SalesConstants.MarketColor.RED,
  //   SalesConstants.MarketColor.SHOPIFY,
  //   SalesConstants.MarketColor.NEONBLUE,
  //   '#4D80CC', '#1AB399', '#ff9400',
  //   '#9900B3', '#E6B333', '#3366E6', '#FF1A66',
  //   '#80B300', '#6680B3', '#CC9999', '#6666FF',
  //   '#CCFF1A', '#4DB380', '#33FFCC', '#4DB3FF',
  //   '#E666B3', '#33991A', '#B3B31A', '#00E680',
  //   '#4D8066', '#E6FF80', '#1AFF33', '#999933',
  //   '#FF3380', '#CCCC00', '#66E64D',
  //   '#E64D66', '#FF4D4D', '#99E6E6'
  // ],
  //
  // DEFAULT_BAR_COLORS: [
  //   SalesConstants.MarketColorGraph.RETAIL,
  //   SalesConstants.MarketColor.SHOPIFY,
  //   SalesConstants.MarketColor.SHOPIFY,
  //   SalesConstants.MarketColor.NEONBLUE
  // ],
  //
  // DEFAULT_GRAPH_COLORS: [
  //   SalesConstants.MarketColorGraph.RETAIL,
  //   SalesConstants.MarketColor.SHOPIFY,
  //   SalesConstants.MarketColor.SHOPIFY,
  //   SalesConstants.MarketColor.NEONBLUE
  // ],

  Logs: {
    COLUMNS: [{
      name: 'logId',
      label: 'ID',
      width: 70,
      // sortable: 'custom'
    }, {
      name: 'created_at',
      label: 'Created At',
      width: 180,
      // sortable: 'custom'
    }, {
      name: 'type',
      label: 'Type',
      width: 120,
      // sortable: 'custom'
    // }, {
    //   name: 'descriptionAll',
    //   label: 'Description',
    //   minWidth: 260,
    //   // sortable: 'custom'
    }, {
      name: 'row',
      label: 'Description',
      type: 'log-cell',
      minWidth: 260,
    }]
  },
})

export default FormConstants
